import $ from 'jquery';
import {showFormResponse} from '../common/json-response';
import {setNotChangedForm} from "./save-work-between-step";
import {setSaveButtonActive, setSaveButtonDisabled} from './work-save-button-toggle'

let saveBtn;

function toggleFields(workUserTypes) {
  let fieldsChanged = false;

  workUserTypes.forEach(function (userType) {
    const fieldsSelector = '.work_user_type_block[data-work-user-type-id="' + userType.value + '"]';
    const fields = document.querySelector(fieldsSelector);

    if (!fields) {
      return;
    }

    let disabledParam;
    if (userType.checked) {
      fields.classList.remove('d-none');
      disabledParam = false;
    } else {
      fields.classList.add('d-none');
      disabledParam = true;
    }

    const fieldsInputs = fields.querySelectorAll('input');
    fieldsInputs.forEach(function (element) {
      element.disabled = disabledParam;
    });

    fieldsChanged = true;
  });

  return fieldsChanged;
}

function toggleRepresentativesFields(currentElement, representatives) {
  representatives.forEach(function (representative) {
    const representativeBlockId = representative.getAttribute('data-params-block-id');
    const fieldsSelector = '.params_block[data-params-block-id="' + representativeBlockId + '"]';
    const fields = document.querySelector(fieldsSelector);

    if (!fields) {
      return;
    }

    const currentBlockId = currentElement.getAttribute('data-params-block-id');
    let disabledParam;

    // если input соответствует выбранному или у выбранного input и текущего input в цикле совпадают
    // типы блока дополнительных полей, тогда не прячем блок дополнительных полей
    if (representative.checked || representativeBlockId == currentBlockId) {
      fields.classList.remove('d-none');
      disabledParam = false;
    } else {
      fields.classList.add('d-none');
      disabledParam = true;
    }

    const fieldsInputs = fields.querySelectorAll('input');
    fieldsInputs.forEach(function (element) {
      element.disabled = disabledParam;
    });
  });
}

function getParticipantFields() {
  const fieldsData = {};

  const checkedUserType = document.querySelector('.work_user_type:checked');
  if (!checkedUserType) {
    return fieldsData;
  }

  const checkedUserTypeValue = checkedUserType.value;
  const fieldsBlockSelector = '.work_user_type_block[data-work-user-type-id="' + checkedUserTypeValue + '"]';
  const fieldsBlock = document.querySelector(fieldsBlockSelector);
  if (!fieldsBlock) {
    return fieldsData;
  }

  const fields = fieldsBlock.querySelectorAll('input, select, textarea');

  fields.forEach((element) => {
    if (element.type == 'radio' || element.type == 'checkbox') {
      if (element.checked) {
        fieldsData[element.name] = element.value;
      }
    } else {
      fieldsData[element.name] = element.value;
    }
  });

  fieldsData['user_type'] = checkedUserTypeValue;
  const email = document.querySelector('input[name="email"]');

  if (email) {
    fieldsData['email'] = email.value.trim().toLowerCase();
  }


  return fieldsData;
}

function initWorkParticipantStep() {
  saveBtn = document.querySelector('#saveBtn[name="work-participant-save"]');

  if (!saveBtn) {
    return;
  }

  let data = {};

  const workUserTypes = document.querySelectorAll('.work_user_type');
  if (workUserTypes.length) {
    toggleFields(workUserTypes);
  }

  workUserTypes?.forEach((userType) => {
    userType.addEventListener('change', (e) => {
      if (toggleFields(workUserTypes)) {
        data['representative'] = null;
      }
    });
  });

  const representatives = document.querySelectorAll('.work_representative');
  representatives?.forEach((representative) => {
    representative.addEventListener('change', (e) => {
      toggleRepresentativesFields(e.target, representatives);
    });
  });

  saveBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    setSaveButtonDisabled(saveBtn);
    // убираем отметку об изменениях в форме
    // чтобы не было двойного сохранения при закрытии страницы после редиректа
    const applicationForm = document.querySelector('.application-form');

    if (applicationForm) {
      const changeParam = applicationForm.querySelector('input[name="application-form-changed"]');
      changeParam.value = 'not-changed';
    }

    data = getParticipantFields();

    if (!data.user_type) {
      setTimeout(() => {
        setSaveButtonActive(saveBtn);
      }, 1000);

      return;
    }

    const requiredPhone = document.querySelector(
      '.work_user_type_block:not(.d-none) input[name="phone"][data-phone-required="1"]'
    );
    if (requiredPhone) {
      const phoneDigits = String(requiredPhone.value || '').replace(/\D/g, '');
      if (phoneDigits.length < 10) {
        showFormResponse({
          status: 'error',
          messages: [{
            messageType: 'field-error',
            parentId: 'phone',
            content: 'Укажите номер телефона',
          }],
        });
        setSaveButtonActive(saveBtn);
        if (typeof window.__hideWbStepLoader === 'function') {
          window.__hideWbStepLoader();
        }
        return;
      }
    }

    const consentCheckboxes = document.querySelectorAll('.work_consent');
    let   consentError = false;
    consentCheckboxes.forEach((checkbox) => {
      const computedStyle = window.getComputedStyle(checkbox);
      const displayValue = computedStyle.getPropertyValue('display');
      if (checkbox.disabled || displayValue === 'none' || checkbox.offsetParent === null) {
        return;
      }

      if (!checkbox.checked) {
        const fieldWrapElement = document.querySelector('[data-message-parent-id="' + checkbox.name + '"]');

        if (!fieldWrapElement) {
          setTimeout(() => {
            setSaveButtonActive(saveBtn);
          }, 1000);

          return;
        }

        const consentErrorMessage = fieldWrapElement.querySelector('.required-consent-error');
        consentErrorMessage.style.display = 'block';
        consentError = true;
      }
    });

    if (consentError) {
      setTimeout(() => {
        setSaveButtonActive(saveBtn);
      }, 1000);

      return;
    }

    const contestWorkConsent = document.querySelector('[name="contest_work_consent"]');

    if (contestWorkConsent) {
      data['contest_work_consent'] = contestWorkConsent.value;
    }

    const participantForm = saveBtn.closest('form');
    if (participantForm) {
      participantForm.querySelectorAll('input[type="hidden"]').forEach((element) => {
        if (!element.name || element.disabled) {
          return;
        }

        data[element.name] = element.value;
      });
    }

    const participantSaveUrl = saveBtn.getAttribute('data-url');

    $.ajax({
      type: 'POST',
      dataType: 'json',
      data: data,
      url: participantSaveUrl,
      success: function (data) {
        // убираем отметку об изменениях в форме
        // чтобы не было двойного сохранения при закрытии страницы после редиректа
        if (data.status === 'success') {
          setNotChangedForm();
        }

        if (data.status === 'success' && data.redirectTo?.length) {
          if (typeof window.__showWbStepLoader === 'function') {
            window.__showWbStepLoader();
          }
          window.location.href = data.redirectTo;
          return;
        }

        showFormResponse(data);
        setSaveButtonActive(saveBtn);
      },
      error: function (data) {
        showFormResponse(data);
        setSaveButtonActive(saveBtn);
      },
    });
  });
}

export { getParticipantFields, initWorkParticipantStep }